import { BUSINESS_TOOL_SECTIONS } from 'constants/businessTool';
import { FOR_BANK_SECTIONS } from 'constants/businessToolSections/forBank';

import { PERIOD_NAMES } from 'components/BusinessToolForm/constants/periods';
import { PREMISES_INFORMATION_NAMES } from 'components/BusinessToolForm/Sections/BusinessOperations/LocationAndPremises/utils/form';
import { CALENDAR_PLAN_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/CashFlowElements/Sections/CalendarPlanForm/utils/form';
import { FUNDING_DIRECTIONS_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/CashFlowElements/Sections/FundingDirectionsForm/utils/form';
import { EFFICIENCY_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/FinancialPerformance/EfficiencyForm/utils/form';
import { INVESTMENT_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/FinancialPerformance/InvestmentForm/utils/form';
import { LIQUIDITY_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/FinancialPerformance/LiquidityForm/utils/form';
import { PROFITABILITY_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/FinancialPerformance/ProfitabilityForm/utils/form';
import { SOLVENCY_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/FinancialPerformance/SolvencyForm/utils/form';
import { COST_OF_EACH_UNIT_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/CostOfEachUnitForm/utils/form';
import { COST_OF_SALES_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/CostOfSalesForm/utils/form';
import { GENERAL_AND_ADMINISTRATIVE_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/GeneralAndAdministrativeForm/utils/form';
import { PERSONNEL_EXPENSES_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/PersonnelExpensesForm/utils/form';
import { R_AND_D_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/RAndDForm/utils/form';
import { SALES_AND_MARKETING_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/SalesAndMarketingForm/utils/form';
import { EXPENSE_TYPE_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/utils/form';
import { NET_INCOME_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProfitAndLossProjection/components/FormSections/NetIncome/utils/form';
import { NET_SALES_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProfitAndLossProjection/components/FormSections/NetSalesForm/utils/form';
import { OPERATING_EXPENSES_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProfitAndLossProjection/components/FormSections/OperatingExpensesForm/utils/form';
import { PROFIT_AND_LOSS_PROJECTION_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProfitAndLossProjection/utils/form';
import { PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedBalanceSheets/utils/form';
import { TOTAL_FIELDS } from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedCashFlow/DirectForm/DirectFormComponents/DirectFormTable/utils/form';
import { FINANCING_ACTIVITIES_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedCashFlow/DirectForm/DirectFormComponents/Sections/FinancingActivities/utils/form';
import { INVESTING_ACTIVITIES_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedCashFlow/DirectForm/DirectFormComponents/Sections/InvestingActivities/utils/form';
import { OPERATING_ACTIVITIES_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedCashFlow/DirectForm/DirectFormComponents/Sections/OperatingActivities/utils/form';
import { PROJECTED_CASH_FLOW_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedCashFlow/utils/form';
import { REVENUE_PLAN_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/RevenuePlan/utils/form';
import { ALL_FIELD_NAMES, GLOBAL_FIELD_NAMES } from 'components/BusinessToolForm/Sections/Global/form';
import { PRODUCT_NAMES } from 'components/BusinessToolForm/Sections/Global/general/products';
import { B2C_NAMES } from 'components/BusinessToolForm/Sections/MarketAnalysis/ConsumerNeeds/utils/form';
import {
  AVERAGE_PRICES_CHART_NAMES,
  MARKET_ANALYSIS_OVERVIEW_NAMES,
} from 'components/BusinessToolForm/Sections/MarketAnalysis/MarketAnalysisOverview/utils/form';

export const overviewGlobalFieldNames = [
  GLOBAL_FIELD_NAMES.COMPANY_NAME,
  GLOBAL_FIELD_NAMES.REGISTRATION_DATE,
  GLOBAL_FIELD_NAMES.ADDRESS,
  GLOBAL_FIELD_NAMES.COMPANY_SECTOR,
  GLOBAL_FIELD_NAMES.NUMBER_OF_EMPLOYEES,
  GLOBAL_FIELD_NAMES.ANNUAL_INCOME,
  GLOBAL_FIELD_NAMES.MAIN_GOALS,
  GLOBAL_FIELD_NAMES.COMPANY_BRIEF_DESCRIPTION,
  GLOBAL_FIELD_NAMES.PROJECT_BRIEF_DESCRIPTION,
  GLOBAL_FIELD_NAMES.COVER_TITLE,
  GLOBAL_FIELD_NAMES.MAIN_PRODUCTS_OR_SERVICES,
  GLOBAL_FIELD_NAMES.STRATEGY_FOR_ACHIEVING_GOALS,
  GLOBAL_FIELD_NAMES.TARGET_MARKET,
  GLOBAL_FIELD_NAMES.TARGET_AUDIENCE,
  GLOBAL_FIELD_NAMES.TARGET_CHANNELS,
  GLOBAL_FIELD_NAMES.MAIN_COMPETITORS,
  GLOBAL_FIELD_NAMES.PROJECTED_ANNUAL_INCOME,
  GLOBAL_FIELD_NAMES.FORECASTED_PROFITABILITY,
  GLOBAL_FIELD_NAMES.PROJECT_PAYBACK_PERIOD,
  GLOBAL_FIELD_NAMES.TOTAL_COST,
  GLOBAL_FIELD_NAMES.FUNDING_AMOUNT,
  GLOBAL_FIELD_NAMES.PERCENTAGE_OF_FUNDING,
];

export const executiveSummaryGlobalFieldNames = [
  GLOBAL_FIELD_NAMES.MAIN_GOALS,
  GLOBAL_FIELD_NAMES.PROJECT_BRIEF_DESCRIPTION,
  GLOBAL_FIELD_NAMES.STRATEGY_FOR_ACHIEVING_GOALS,
  GLOBAL_FIELD_NAMES.COMPANY_NAME,
  GLOBAL_FIELD_NAMES.REGISTRATION_DATE,
  GLOBAL_FIELD_NAMES.ADDRESS,
  GLOBAL_FIELD_NAMES.COMPANY_SECTOR,
  GLOBAL_FIELD_NAMES.MISSION,
  GLOBAL_FIELD_NAMES.MAIN_PRODUCTS_OR_SERVICES,
  GLOBAL_FIELD_NAMES.COMPETITIVE_ADVANTAGE,
  GLOBAL_FIELD_NAMES.PRODUCT_DEVELOPMENT_PLANS,
  GLOBAL_FIELD_NAMES.TARGET_MARKET,
  GLOBAL_FIELD_NAMES.TARGET_AUDIENCE,
  GLOBAL_FIELD_NAMES.TARGET_CHANNELS,
  GLOBAL_FIELD_NAMES.MAIN_COMPETITORS,
  GLOBAL_FIELD_NAMES.ANNUAL_INCOME,
  GLOBAL_FIELD_NAMES.PROJECTED_ANNUAL_INCOME,
  GLOBAL_FIELD_NAMES.FORECASTED_PROFITABILITY,
  GLOBAL_FIELD_NAMES.PROJECT_PAYBACK_PERIOD,
  GLOBAL_FIELD_NAMES.TOTAL_COST,
  GLOBAL_FIELD_NAMES.FUNDING_AMOUNT,
  GLOBAL_FIELD_NAMES.PERCENTAGE_OF_FUNDING,
  GLOBAL_FIELD_NAMES.INVESTMENT_AMOUNT,
  GLOBAL_FIELD_NAMES.LOAN_BORROW_AMOUNT,
];

export const aboutCompanyGlobalFieldNames = [
  GLOBAL_FIELD_NAMES.COMPANY_BRIEF_DESCRIPTION,
  GLOBAL_FIELD_NAMES.COMPANY_NAME,
  GLOBAL_FIELD_NAMES.COMPANY_SECTOR,
  GLOBAL_FIELD_NAMES.NUMBER_OF_EMPLOYEES,
  GLOBAL_FIELD_NAMES.ADDRESS,
  GLOBAL_FIELD_NAMES.REGISTRATION_DATE,
  GLOBAL_FIELD_NAMES.MISSION,
  GLOBAL_FIELD_NAMES.COMPANY_STRENGTHS,
  GLOBAL_FIELD_NAMES.COMPANY_WEAKNESSES,
];

export const productsAndServicesGlobalFieldNames = [
  GLOBAL_FIELD_NAMES.COMPETITIVE_ADVANTAGE,
  GLOBAL_FIELD_NAMES.PRODUCT_DEVELOPMENT_PLANS,
];

export const marketAnalysisGlobalFieldNames = [
  GLOBAL_FIELD_NAMES.COMPANY_STRENGTHS,
  GLOBAL_FIELD_NAMES.COMPANY_WEAKNESSES,
];

export const marketAnalysisExcludeFields = [
  MARKET_ANALYSIS_OVERVIEW_NAMES.AVERAGE_PRICES_CURRENCY,
  AVERAGE_PRICES_CHART_NAMES.AVERAGE_PRICES_REGIONS_HEADINGS,
  ALL_FIELD_NAMES.COMPETITIVE_ANALYSIS.COMPETITORS_QUALITIES,
  B2C_NAMES.GENDER,

  'marketOverview.forecastedConsumptionChart[0].title',
  'marketOverview.forecastedConsumptionChart[0].region',
  'marketOverview.forecastedConsumptionChart[0].units.selectedUnits',
  'marketOverview.forecastedConsumptionChart[0].units.volume',
  'marketOverview.forecastedConsumptionChart[0].units.currency',
  'marketOverview.currentMarketStructure[0].title',
  'marketOverview.currentMarketStructure[0].consumer',
  'marketOverview.currentMarketStructure[0].units.selectedUnits',
  'marketOverview.currentMarketStructure[0].units.volume',
  'marketOverview.currentMarketStructure[0].units.currency',
  'marketOverview.currentMarketStructure[0].consumerDetails[0].monetaryShare',

  'competitiveAnalysis.comparisonItem[0].featuresForComparison',
  'competitiveAnalysis.comparisonItem[0].competitorFeaturesList',
  'competitiveAnalysis.keyCompetitors[0].customerLoyaltyLevel',
  'competitiveAnalysis.comparisonItem[0].featuresList',

  'forecastedConsumptionChart[0].tableHeadings',
  'companyStrengths[0].title',
  'companyWeaknesses[0].title',
  'file',
];

export const businessOperationsGlobalFieldNames = [GLOBAL_FIELD_NAMES.PRODUCTS];

export const raisingAndAllocatingGlobalFieldNames = [
  GLOBAL_FIELD_NAMES.TOTAL_COST,
  GLOBAL_FIELD_NAMES.PERCENTAGE_OF_FUNDING,
  GLOBAL_FIELD_NAMES.FUNDING_AMOUNT,
  GLOBAL_FIELD_NAMES.LOAN_BORROW_AMOUNT,
  GLOBAL_FIELD_NAMES.INVESTMENT_AMOUNT,
];

export const forBankSectionsMap = {
  [FOR_BANK_SECTIONS.OVERVIEW]: {
    chapterName: BUSINESS_TOOL_SECTIONS.OVERVIEW,
    globalFields: overviewGlobalFieldNames,
    fieldsToIgnore: [],
    checkOnlyTheseFields: overviewGlobalFieldNames,
  },
  [FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY]: {
    chapterName: BUSINESS_TOOL_SECTIONS.EXECUTIVE_SUMMARY,
    globalFields: executiveSummaryGlobalFieldNames,
    fieldsToIgnore: [],
    checkOnlyTheseFields: [],
  },
  [FOR_BANK_SECTIONS.ABOUT_COMPANY]: {
    chapterName: BUSINESS_TOOL_SECTIONS.ABOUT_COMPANY,
    globalFields: aboutCompanyGlobalFieldNames,
    fieldsToIgnore: [
      'missionAndStrategy.goals[0].priority.value',
      'missionAndStrategy.goals[0].priority.label',
      'missionAndStrategy.goals[0].terms.value',
      'missionAndStrategy.goals[0].terms.label',
    ],
    checkOnlyTheseFields: [],
  },
  [FOR_BANK_SECTIONS.PRODUCTS_AND_SERVICES]: {
    chapterName: BUSINESS_TOOL_SECTIONS.PRODUCTS_AND_SERVICES,
    globalFields: productsAndServicesGlobalFieldNames,
    fieldsToIgnore: ['randd.timelines[0].status.value', 'randd.timelines[0].status.label'],
    checkOnlyTheseFields: [],
  },
  [FOR_BANK_SECTIONS.MARKET_ANALYSIS]: {
    chapterName: BUSINESS_TOOL_SECTIONS.MARKET_ANALYSIS,
    globalFields: marketAnalysisGlobalFieldNames,
    fieldsToIgnore: marketAnalysisExcludeFields,
    checkOnlyTheseFields: [],
  },
  [FOR_BANK_SECTIONS.MARKETING_AND_SALES]: {
    chapterName: BUSINESS_TOOL_SECTIONS.MARKETING_AND_SALES,
    globalFields: [],
    fieldsToIgnore: [
      ALL_FIELD_NAMES.SALES_PLAN.TOTAL_PLANNED_PRODUCTS_VOLUME,
      ALL_FIELD_NAMES.MARKETING_PLAN.BRAND_ELEMENTS,
    ],
    checkOnlyTheseFields: [],
  },
  [FOR_BANK_SECTIONS.BUSINESS_OPERATIONS]: {
    chapterName: BUSINESS_TOOL_SECTIONS.BUSINESS_OPERATIONS,
    globalFields: businessOperationsGlobalFieldNames,
    fieldsToIgnore: [
      PRODUCT_NAMES.PRODUCT_ID,
      PRODUCT_NAMES.MONTHLY_SALES_PLAN_MONETARY,
      PREMISES_INFORMATION_NAMES.TERMS_OF_USE,
      'file',
      'products',
      'partnersSection.keySuppliers[0].deliveryTerms',
    ],
    checkOnlyTheseFields: [],
  },
  [FOR_BANK_SECTIONS.MANAGEMENT_AND_ORGANIZATION]: {
    chapterName: BUSINESS_TOOL_SECTIONS.MANAGEMENT_AND_ORGANIZATION,
    globalFields: [],
    fieldsToIgnore: [],
    checkOnlyTheseFields: [],
  },
  [FOR_BANK_SECTIONS.IMPLEMENTATION_PLAN]: {
    chapterName: BUSINESS_TOOL_SECTIONS.IMPLEMENTATION_PLAN,
    globalFields: [],
    fieldsToIgnore: ['stages[0].status.value', 'stages[0].status.label'],
    checkOnlyTheseFields: [],
  },
  [FOR_BANK_SECTIONS.RAISING_AND_ALLOCATING_FUNDS]: {
    chapterName: BUSINESS_TOOL_SECTIONS.RAISING_AND_ALLOCATING_FUNDS,
    globalFields: raisingAndAllocatingGlobalFieldNames,
    fieldsToIgnore: ['percentageOfFunding', 'financedPortionCost'],
    checkOnlyTheseFields: [],
  },
  [FOR_BANK_SECTIONS.LEGAL_FRAMEWORKS_AND_RISKS]: {
    chapterName: BUSINESS_TOOL_SECTIONS.LEGAL_FRAMEWORKS_AND_RISKS,
    globalFields: [],
    fieldsToIgnore: [],
    checkOnlyTheseFields: [],
  },
  [FOR_BANK_SECTIONS.FINANCIAL_PLAN]: {
    chapterName: BUSINESS_TOOL_SECTIONS.FINANCIAL_PLAN,
    globalFields: [],
    checkOnlyTheseFields: [],
    fieldsToIgnore: [
      'rowItemName',
      'financialPerformance.investment.discountRate',
      'openingBalanceSheets.initialAssets.currentAssets.creditSalesPaymentDuration',
      'openingBalanceSheets.initialLiabilities.currentLiabilities.paymentDurationCreditPurchases',
      'openingBalanceSheets.isEqual',

      ALL_FIELD_NAMES.PLANNED_EXPENSES.MONTHLY_EXPENSES.NON_OPERATING_EXPENSES,
      ALL_FIELD_NAMES.PLANNED_EXPENSES.MONTHLY_EXPENSES.NON_OPERATING_GROWTH_RATE,
      ALL_FIELD_NAMES.PLANNED_EXPENSES.MONTHLY_EXPENSES.NON_OPERATING_REVENUE,
      ALL_FIELD_NAMES.OPENING_BALANCE_SHEETS.INITIAL_LIABILITIES.CURRENT_LIABILITIES.PERCENT_CREDIT_PURCHASES,
      ALL_FIELD_NAMES.OPENING_BALANCE_SHEETS.INITIAL_LIABILITIES.CURRENT_LIABILITIES.SHORT_TERM_DEBT,
      ALL_FIELD_NAMES.OPENING_BALANCE_SHEETS.INITIAL_LIABILITIES.CURRENT_LIABILITIES.CURRENT_PORTION_LONG_TERM_DEBT,
      ALL_FIELD_NAMES.OPENING_BALANCE_SHEETS.INITIAL_LIABILITIES.CURRENT_LIABILITIES.ACCRUED_LIABILITIES,
      ALL_FIELD_NAMES.OPENING_BALANCE_SHEETS.INITIAL_LIABILITIES.CURRENT_LIABILITIES.DEFERRED_TAX_LIABILITIES,
      ALL_FIELD_NAMES.OPENING_BALANCE_SHEETS.INITIAL_LIABILITIES.CURRENT_LIABILITIES.PROVISIONS,
      ALL_FIELD_NAMES.OPENING_BALANCE_SHEETS.INITIAL_LIABILITIES.CURRENT_LIABILITIES.OTHER_CURRENT_LIABILITIES,
      ALL_FIELD_NAMES.OPENING_BALANCE_SHEETS.INITIAL_LIABILITIES.NON_CURRENT_LIABILITIES.DEFERRED_TAX_LIABILITIES,
      ALL_FIELD_NAMES.OPENING_BALANCE_SHEETS.INITIAL_LIABILITIES.NON_CURRENT_LIABILITIES.PROVISIONS_NON_CURRENT,
      ALL_FIELD_NAMES.OPENING_BALANCE_SHEETS.INITIAL_LIABILITIES.NON_CURRENT_LIABILITIES.OTHER_NON_CURRENT_LIABILITIES,
      ALL_FIELD_NAMES.OPENING_BALANCE_SHEETS.INITIAL_EQUITY.ADDITIONAL_PAID_IN_CAPITAL,
      ALL_FIELD_NAMES.OPENING_BALANCE_SHEETS.INITIAL_EQUITY.RESERVES,
      ALL_FIELD_NAMES.OPENING_BALANCE_SHEETS.INITIAL_EQUITY.ACCUMULATED_OTHER_COMPREHENSIVE_INCOME,
      ALL_FIELD_NAMES.OPENING_BALANCE_SHEETS.INITIAL_EQUITY.RETAINED_EARNINGS,
      REVENUE_PLAN_NAMES.PLANNED_PRODUCTS_VOLUME_TOTAL,
      REVENUE_PLAN_NAMES.PLANNED_PRODUCTS_VOLUME,
      INVESTMENT_FORM_NAMES.INVESTMENT_TABLE,
      PROFITABILITY_FORM_NAMES.PROFITABILITY_TABLE,
      PROFITABILITY_FORM_NAMES.PROFITABILITY_TOTAL,
      PROFITABILITY_FORM_NAMES.PROFITABILITY_VARIANTS,
      LIQUIDITY_FORM_NAMES.LIQUIDITY_TABLE,
      LIQUIDITY_FORM_NAMES.LIQUIDITY_VARIANTS,
      EFFICIENCY_FORM_NAMES.EFFICIENCY_TABLE,
      EFFICIENCY_FORM_NAMES.EFFICIENCY_VARIANTS,
      SOLVENCY_FORM_NAMES.SOLVENCY_TABLE,
      SOLVENCY_FORM_NAMES.SOLVENCY_VARIANTS,
      PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES.ASSETS,
      PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES.LIABILITIES_AND_EQUITY,
      PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES.COMPANY_MAIN_COMPONENTS,
      PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES.SHORT_TERM_LIABILITIES_FINANCE,
      PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES.NON_CURRENT_ASSETS_CHANGE,
      PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES.STRUCTURE_OF_NON_CURRENT_ASSETS,
      PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES.SHORT_TERM_LIABILITIES_MAIN_COMPONENTS,
      PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES.SHORT_TERM_FINANCING_SOURCES,
      PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES.LONG_TERM_LIABILITIES_MAIN_COMPONENTS,
      PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES.COMPANY_EQUITY_STRUCTURE,
      EXPENSE_TYPE_NAMES.TOTAL_EXPENSES,
      PROFIT_AND_LOSS_PROJECTION_FORM_NAMES.TABLE,
      PROFIT_AND_LOSS_PROJECTION_FORM_NAMES.ESTIMATED_TAX_RATE,
      CALENDAR_PLAN_NAMES.TOTAL,
      CALENDAR_PLAN_NAMES.CURRENCY,
      FUNDING_DIRECTIONS_NAMES.EQUIPMENT_PURCHASE_SUB_ROW,
      FUNDING_DIRECTIONS_NAMES.CONSTRUCTION_SUB_ROW,
      FUNDING_DIRECTIONS_NAMES.MARKETING_AND_SALES_SUB_ROWS,
      FUNDING_DIRECTIONS_NAMES.R_AND_D_SUB_ROWS,
      FUNDING_DIRECTIONS_NAMES.OTHER_SUB_ROW,
      FUNDING_DIRECTIONS_NAMES.WORKING_CAPITAL_SUB_ROW,
      FUNDING_DIRECTIONS_NAMES.VARIANTS,
      PROJECTED_CASH_FLOW_FORM_NAMES.SELECTED_TYPE,
      NET_SALES_NAMES.NET_SALES,
      NET_INCOME_NAMES.NET_INCOME,
      COST_OF_SALES_FORM_NAMES.CONST_OF_SALES_CURRENCY,
      R_AND_D_FORM_NAMES.R_AND_D_CURRENCY,
      SALES_AND_MARKETING_FORM_NAMES.SALES_AND_MARKETING_CURRENCY,
      GENERAL_AND_ADMINISTRATIVE_FORM_NAMES.GENERAL_AND_ADMINISTRATIVE_CURRENCY,
      COST_OF_EACH_UNIT_FORM_NAMES.CONST_OF_EACH_UNIT_CURRENCY,
      PERSONNEL_EXPENSES_FORM_NAMES.PERSONNEL_EXPENSES_VARIANTS,
      PERSONNEL_EXPENSES_FORM_NAMES.PERSONNEL_EXPENSES_HEADER,
      OPERATING_ACTIVITIES_NAMES.INTEREST_RECEIVED,
      OPERATING_EXPENSES_NAMES.R_AND_D,
      OPERATING_EXPENSES_NAMES.OTHER_OPERATING_EXPENSES,
      OPERATING_EXPENSES_NAMES.TOTAL_OPERATING_EXPENSES,
      OPERATING_EXPENSES_NAMES.SALES_AND_MARKETING,
      OPERATING_EXPENSES_NAMES.GENERAL_AND_ADMINISTRATIVE,
      INVESTING_ACTIVITIES_NAMES.PURCHASE_PROPERTY_PLANT_EQUIPMENT,
      PERIOD_NAMES.HALF_VALUES,
      PERIOD_NAMES.MONTH_VALUES,
      PERIOD_NAMES.QUARTER_VALUES,
      PERIOD_NAMES.YEAR_VALUES,
      // TODO delete if client agreed
      // INVESTING_ACTIVITIES_NAMES.LOSS_ON_SALE_OF_ASSETS,
      FINANCING_ACTIVITIES_NAMES.PROCEEDS_ISSUANCE_DEBT,
      FINANCING_ACTIVITIES_NAMES.REPAYMENT_DEBT,
      FINANCING_ACTIVITIES_NAMES.PROCEEDS_ISSUANCE_EQUITY,
      OPERATING_ACTIVITIES_NAMES.CASH_PAID_EMPLOYEES,
      OPERATING_ACTIVITIES_NAMES.CASH_PAID_SUPPLIERS,
      OPERATING_ACTIVITIES_NAMES.CASH_PAID_OTHER_OPERATING_EXPENSES,
      OPERATING_ACTIVITIES_NAMES.CASH_RECEIVED_CUSTOMERS,
      OPERATING_ACTIVITIES_NAMES.INTEREST_PAID,
      OPERATING_ACTIVITIES_NAMES.INCOME_TAXES_PAID,
      OPERATING_ACTIVITIES_NAMES.NET_CASH_OPERATING_ACTIVITIES,
      PROJECTED_CASH_FLOW_FORM_NAMES.IN_DIRECT,
      TOTAL_FIELDS.NET_INCREASE_DECREASE_CASH_EQUIVALENTS.name,
      TOTAL_FIELDS.CASH_EQUIVALENTS_BEGINNING_PERIOD.name,
      TOTAL_FIELDS.CASH_EQUIVALENTS_END_PERIOD.name,
      PROJECTED_CASH_FLOW_FORM_NAMES.AMORTIZATIONS,
      PROJECTED_CASH_FLOW_FORM_NAMES.DEPRECATION,
    ],
  },
};
